import { AlignType } from '@meitu/saas-editor-core/es/version-types';
import { baseTrack, type BaseTrackPayload } from './base';

type Payload = Omit<BaseTrackPayload, 'funcId'> & { firstId: number };

export const CommonToolTracker = {
    flip(payload: Payload & { flip: 'horizontal' | 'vertical' }) {
        const { firstId, flip, ...rest } = payload;
        const secondId = flip === 'horizontal' ? 4 : 5;
        const funcId = `${firstId}_${secondId}`;
        const basePayload = { ...rest, funcId };

        baseTrack(basePayload, ['click', 'use']);
    },

    lock(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_22`;
        const basePayload = { ...rest, funcId };

        baseTrack(basePayload, ['click', 'use']);
    },

    copy(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_24`;
        const basePayload = { ...rest, funcId };

        baseTrack(basePayload, ['click', 'use']);
    },

    sort(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_23`;
        const basePayload = { ...rest, funcId };

        baseTrack(basePayload, ['click', 'use']);
    },

    delete(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_25`;
        const basePayload = { ...rest, funcId };

        baseTrack(basePayload, ['click', 'use']);
    },

    copyBrush(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_73`;
        const basePayload = { ...rest, funcId };
        baseTrack(basePayload, ['click']);
    },

    applyBrush(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_73`;
        const basePayload = { ...rest, funcId };
        baseTrack(basePayload, ['use']);
    },

    size(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_166`;
        const basePayload = { ...rest, funcId };

        baseTrack(basePayload, ['click', 'use']);
    },

    rotate(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_167`;
        const basePayload = { ...rest, funcId };

        baseTrack(basePayload, ['click', 'use']);
    },

    position(payload: Payload) {
        const { firstId, ...rest } = payload;
        const funcId = `${firstId}_168`;
        const basePayload = { ...rest, funcId };
        baseTrack(basePayload, ['click', 'use']);
    },

    align(payload: Payload & { type: AlignType }) {
        const { firstId, type, ...rest } = payload;
        const __type = type === AlignType.group ? 45 : 44;
        const funcId = `${firstId}_${__type}`;
        const basePayload = { ...rest, funcId };
        baseTrack(basePayload, ['click', 'use']);
    },
};
